export default __webpack_public_path__ + "static/media/logo-rosu-maro.8e94dbf9.png";